var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_65_1",
    "data-name": "Component 65 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 17.997 22.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M8865.685,7811h-6.827a1,1,0,0,1-.854-.962V7790.17a1.054,1.054,0,0,1,1.181-1.169h12.534a.735.735,0,0,1,.521.226l3.56,3.626a.692.692,0,0,1,.2.5v16.56a1.175,1.175,0,0,1-.281.788,1.071,1.071,0,0,1-.811.3Zm6.315-7a2,2,0,1,0,2,2A2,2,0,0,0,8872,7804Zm-11.5,3a.5.5,0,0,0,0,1h7a.5.5,0,0,0,0-1Zm0-3a.5.5,0,0,0,0,1h7a.5.5,0,0,0,0-1Zm0-3a.5.5,0,0,0,0,1h9a.5.5,0,0,0,0-1Zm0-3a.5.5,0,0,0,0,1h13a.5.5,0,1,0,0-1Zm0-3a.5.5,0,0,0,0,1h13a.5.5,0,1,0,0-1Zm0-3a.5.5,0,0,0,0,1h8a.5.5,0,0,0,0-1Zm11.514-1.282,0,0a.09.09,0,0,1-.009.015l.012.012c0,.244,0,.489,0,.734,0,.362,0,.736,0,1.1a.135.135,0,0,0,.027.1.144.144,0,0,0,.106.025h.024q.719,0,1.437,0H8874l.035-.071c-.721-.677-1.4-1.314-2.018-1.891v-.031ZM8872,7807a1,1,0,1,1,1-1A1,1,0,0,1,8872,7807Z",
    transform: "translate(-8858.002 -7789)",
    fill: "#5f5f5f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.332aa0ff85d371520575e36aa337b409.svg";
export { ForwardRef as ReactComponent };